import { formatNumber } from "./formatNumber";

const kronerAndOre = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatMoney = (value: number): string =>
  Number.isInteger(value) ? formatNumber(value) : kronerAndOre.format(value);

export const displaySum = (props: { value?: number | null; currency: string }) => {
  return `${formatMoney(props.value ?? 0)} ${props.currency}`;
};
